
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.17.0
 * Query Engine version: e9771e62de70f79a5e1c604a2d7c8e2a0a874b48
 */
Prisma.prismaVersion = {
  client: "5.17.0",
  engine: "e9771e62de70f79a5e1c604a2d7c8e2a0a874b48"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  emailValidated: 'emailValidated',
  firstName: 'firstName',
  lastName: 'lastName',
  username: 'username',
  dob: 'dob',
  hashedPassword: 'hashedPassword',
  passwordLastUpdated: 'passwordLastUpdated',
  salt: 'salt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resetToken: 'resetToken',
  resetTokenExpiresAt: 'resetTokenExpiresAt',
  phoneNumber: 'phoneNumber',
  phoneNumberValidated: 'phoneNumberValidated',
  otpSecret: 'otpSecret',
  otpVerifiedAt: 'otpVerifiedAt',
  has2FA: 'has2FA',
  status: 'status',
  countryCode: 'countryCode',
  partnerId: 'partnerId',
  businessId: 'businessId',
  roleId: 'roleId',
  merchantId: 'merchantId',
  subPartnerId: 'subPartnerId',
  invitedAt: 'invitedAt',
  invitedBy: 'invitedBy',
  activationExpiresAt: 'activationExpiresAt',
  reactivationRequestedAt: 'reactivationRequestedAt',
  lockedAt: 'lockedAt',
  lockedBy: 'lockedBy',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  folderName: 'folderName',
  loginAttempts: 'loginAttempts',
  loginBlockedUntil: 'loginBlockedUntil',
  sellerId: 'sellerId',
  pipeDriveUserId: 'pipeDriveUserId',
  zenDeskUserId: 'zenDeskUserId',
  userId: 'userId'
};

exports.Prisma.BusinessScalarFieldEnum = {
  id: 'id',
  hierarchyLevel: 'hierarchyLevel',
  legalName: 'legalName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  partnerId: 'partnerId',
  partnerOfPartnerId: 'partnerOfPartnerId',
  bankId: 'bankId',
  status: 'status',
  registeredNumber: 'registeredNumber',
  tradingName: 'tradingName',
  website: 'website',
  creditLimit: 'creditLimit',
  vatNumber: 'vatNumber',
  vatValidatedAt: 'vatValidatedAt',
  paymentTerms: 'paymentTerms',
  currency: 'currency',
  language: 'language',
  taCode: 'taCode',
  membershipNumber: 'membershipNumber',
  worldPayID: 'worldPayID',
  createdBy: 'createdBy',
  deletedBy: 'deletedBy',
  businessType: 'businessType',
  accountManagerId: 'accountManagerId',
  merchantId: 'merchantId'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  hierarchyLevel: 'hierarchyLevel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RolePermissionsScalarFieldEnum = {
  id: 'id',
  addPartner: 'addPartner',
  viewPartner: 'viewPartner',
  editPartner: 'editPartner',
  changePartnerStatus: 'changePartnerStatus',
  addMerchant: 'addMerchant',
  addService: 'addService',
  viewMerchant: 'viewMerchant',
  editMerchant: 'editMerchant',
  cancelServices: 'cancelServices',
  changeMerchantStatus: 'changeMerchantStatus',
  unmaskPll: 'unmaskPll',
  leadManagement: 'leadManagement',
  pricingAndProductManagement: 'pricingAndProductManagement',
  reportingExcludingFinance: 'reportingExcludingFinance',
  reportingIncludingFinance: 'reportingIncludingFinance',
  stockManagement: 'stockManagement',
  viewFinance: 'viewFinance',
  viewCommissions: 'viewCommissions',
  viewSelfBillingInvoices: 'viewSelfBillingInvoices',
  addInvoice: 'addInvoice',
  addPayment: 'addPayment',
  addCredit: 'addCredit',
  partnerShop: 'partnerShop',
  serviceDesk: 'serviceDesk',
  configurationUserManagement: 'configurationUserManagement',
  configurationAuditLog: 'configurationAuditLog',
  configurationFinance: 'configurationFinance',
  configurationSage: 'configurationSage',
  configurationOther: 'configurationOther',
  customerSuccess: 'customerSuccess',
  managePartnerResources: 'managePartnerResources',
  configurationPartnerResources: 'configurationPartnerResources',
  roleId: 'roleId'
};

exports.Prisma.PasswordScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  hashedPassword: 'hashedPassword',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  eircode: 'eircode',
  addressOne: 'addressOne',
  addressTwo: 'addressTwo',
  locationId: 'locationId',
  emailLookup: 'emailLookup',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  deletedBy: 'deletedBy',
  deletedAt: 'deletedAt',
  userId: 'userId'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type'
};

exports.Prisma.PartnerScalarFieldEnum = {
  id: 'id',
  statementFrequency: 'statementFrequency',
  partnerAccountNumber: 'partnerAccountNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  telephoneNumber: 'telephoneNumber',
  mobilePhoneNumber: 'mobilePhoneNumber',
  contract: 'contract',
  primaryContactInformation: 'primaryContactInformation',
  billingContactInformation: 'billingContactInformation',
  serviceContactInformation: 'serviceContactInformation',
  createdAt: 'createdAt',
  isForTestingCommission: 'isForTestingCommission',
  updatedAt: 'updatedAt',
  sageContactId: 'sageContactId',
  addPartnerApplicationId: 'addPartnerApplicationId',
  logo: 'logo',
  country: 'country',
  accountingId: 'accountingId'
};

exports.Prisma.PartnerOfPartnerScalarFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  statementFrequency: 'statementFrequency',
  partnerOfAccountNumber: 'partnerOfAccountNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  telephoneNumber: 'telephoneNumber',
  mobilePhoneNumber: 'mobilePhoneNumber',
  primaryContactInformation: 'primaryContactInformation',
  billingContactInformation: 'billingContactInformation',
  serviceContactInformation: 'serviceContactInformation',
  contract: 'contract',
  createdAt: 'createdAt',
  logo: 'logo',
  country: 'country'
};

exports.Prisma.MerchantScalarFieldEnum = {
  id: 'id',
  mccId: 'mccId',
  risk: 'risk',
  partnerOfPartnerId: 'partnerOfPartnerId',
  partnerId: 'partnerId',
  mid: 'mid',
  applicationId: 'applicationId',
  status: 'status',
  terminalId: 'terminalId',
  updatedAt: 'updatedAt',
  accountingId: 'accountingId',
  sageContactId: 'sageContactId',
  sageDisplayedAs: 'sageDisplayedAs',
  sageResourcePath: 'sageResourcePath',
  sageContactCreatedAt: 'sageContactCreatedAt',
  activationDate: 'activationDate',
  merchantAccountNumber: 'merchantAccountNumber'
};

exports.Prisma.MCCScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  risk: 'risk',
  description: 'description',
  formattedDescription: 'formattedDescription',
  documents: 'documents',
  formattedDocuments: 'formattedDocuments',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BankScalarFieldEnum = {
  id: 'id',
  iban: 'iban',
  bic: 'bic',
  validatedAt: 'validatedAt',
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedById: 'updatedById',
  updatedAt: 'updatedAt',
  deletedById: 'deletedById',
  accountType: 'accountType',
  merchantId: 'merchantId',
  accountName: 'accountName',
  sortCode: 'sortCode',
  accountNumber: 'accountNumber',
  bankName: 'bankName',
  branch: 'branch',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  town: 'town',
  postCode: 'postCode'
};

exports.Prisma.OutletScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  addressId: 'addressId',
  name: 'name',
  serviceCharges: 'serviceCharges'
};

exports.Prisma.NoteScalarFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  partnerOfPartnerId: 'partnerOfPartnerId',
  merchantId: 'merchantId',
  body: 'body',
  subject: 'subject',
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  applicationId: 'applicationId'
};

exports.Prisma.DocumentScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  locationURL: 'locationURL',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  merchantId: 'merchantId',
  partnerId: 'partnerId',
  fileType: 'fileType',
  fileName: 'fileName'
};

exports.Prisma.CommissionScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  createdAt: 'createdAt',
  commissionType: 'commissionType',
  commissionStatementId: 'commissionStatementId',
  serviceId: 'serviceId',
  setupAndAccessoryAmount: 'setupAndAccessoryAmount',
  monthlyAmount: 'monthlyAmount',
  totalAmount: 'totalAmount'
};

exports.Prisma.OfferScalarFieldEnum = {
  id: 'id',
  name: 'name',
  term: 'term',
  customTerm: 'customTerm',
  type: 'type',
  status: 'status',
  assigned_total: 'assigned_total',
  primaryProductIds: 'primaryProductIds',
  secondaryProductIds: 'secondaryProductIds',
  salesConditions: 'salesConditions',
  mccConditions: 'mccConditions',
  gpvConditions: 'gpvConditions',
  gpvLowest: 'gpvLowest',
  gpvHighest: 'gpvHighest',
  allPartners: 'allPartners',
  legacyAt: 'legacyAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  catalogue: 'catalogue',
  type: 'type',
  description: 'description',
  imageUrl: 'imageUrl',
  status: 'status',
  primaryProductIds: 'primaryProductIds',
  secondaryProductIds: 'secondaryProductIds',
  term: 'term',
  connectivity: 'connectivity',
  price: 'price',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  terminalId: 'terminalId',
  onlineId: 'onlineId',
  sageLedgerId: 'sageLedgerId'
};

exports.Prisma.TerminalProductIdScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.OnlineProductIdScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  url: 'url',
  productId: 'productId'
};

exports.Prisma.PricingScalarFieldEnum = {
  id: 'id',
  serviceType: 'serviceType',
  cost: 'cost',
  npiBuildPrice: 'npiBuildPrice',
  partnerBuidlPrice: 'partnerBuidlPrice',
  businessId: 'businessId',
  name: 'name',
  term: 'term',
  status: 'status',
  pciComplianceFeeProgramme: 'pciComplianceFeeProgramme',
  pciComplianceRate: 'pciComplianceRate',
  safePayNonComplianceChargeBase: 'safePayNonComplianceChargeBase',
  safePayNonComplianceChargeHighest: 'safePayNonComplianceChargeHighest',
  safePayNonComplianceChargeLowest: 'safePayNonComplianceChargeLowest',
  safePayVulnerabilityScanFeeBase: 'safePayVulnerabilityScanFeeBase',
  safePayVulnerabilityScanFeeLowest: 'safePayVulnerabilityScanFeeLowest',
  safePayVulnerabilityScanFeeHighest: 'safePayVulnerabilityScanFeeHighest',
  safePayServiceFeeBase: 'safePayServiceFeeBase',
  safePayServiceFeeLowest: 'safePayServiceFeeLowest',
  safePayServiceFeeHighest: 'safePayServiceFeeHighest',
  type: 'type',
  catalogue: 'catalogue',
  prices: 'prices',
  productId: 'productId',
  offerId: 'offerId'
};

exports.Prisma.PromoScalarFieldEnum = {
  id: 'id',
  applyPromo: 'applyPromo',
  productId: 'productId',
  offerId: 'offerId'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  to: 'to',
  date: 'date',
  dueDate: 'dueDate',
  billingCycle: 'billingCycle',
  occurrence: 'occurrence',
  occurrenceType: 'occurrenceType',
  frequency: 'frequency',
  recurringStartDate: 'recurringStartDate',
  numberOfInvoices: 'numberOfInvoices',
  comments: 'comments',
  totalNetAmount: 'totalNetAmount',
  totalVatAmount: 'totalVatAmount',
  totalInvoiceAmount: 'totalInvoiceAmount',
  totalOutstanding: 'totalOutstanding',
  status: 'status',
  createdAt: 'createdAt',
  createdAtDate: 'createdAtDate',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  partnerId: 'partnerId',
  merchantId: 'merchantId',
  sageId: 'sageId',
  sageInvoiceId: 'sageInvoiceId',
  sageSentAt: 'sageSentAt',
  sageResourcePath: 'sageResourcePath',
  sageInvoiceNumber: 'sageInvoiceNumber',
  sageInvoiceStatus: 'sageInvoiceStatus',
  isAutomated: 'isAutomated'
};

exports.Prisma.InvoiceItemScalarFieldEnum = {
  id: 'id',
  ledgerAccount: 'ledgerAccount',
  description: 'description',
  quantity: 'quantity',
  netAmount: 'netAmount',
  totalNet: 'totalNet',
  totalVat: 'totalVat',
  lineTotal: 'lineTotal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invoiceId: 'invoiceId',
  sageInvoiceItemId: 'sageInvoiceItemId'
};

exports.Prisma.AddPartnerApplicationScalarFieldEnum = {
  id: 'id',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  step: 'step',
  partnerType: 'partnerType',
  partnerId: 'partnerId',
  partnerOfPartner: 'partnerOfPartner',
  pi_BusinessType: 'pi_BusinessType',
  pi_legalCompanyName: 'pi_legalCompanyName',
  pi_website: 'pi_website',
  pi_registeredNumber: 'pi_registeredNumber',
  pi_vatRegistered: 'pi_vatRegistered',
  pi_tradingName: 'pi_tradingName',
  pi_vatNumber: 'pi_vatNumber',
  pi_accountManager: 'pi_accountManager',
  pi_creditLimit: 'pi_creditLimit',
  pi_paymentTerms: 'pi_paymentTerms',
  ai_ra_eircode: 'ai_ra_eircode',
  ai_ra_addressLine1: 'ai_ra_addressLine1',
  ai_ra_addressLine2: 'ai_ra_addressLine2',
  ai_ra_city: 'ai_ra_city',
  ai_ra_country: 'ai_ra_country',
  ai_ra_county: 'ai_ra_county',
  ai_ra_countryCode: 'ai_ra_countryCode',
  ai_ra_tradingAddressSameAsRegisteredAddress: 'ai_ra_tradingAddressSameAsRegisteredAddress',
  ai_ta_eircode: 'ai_ta_eircode',
  ai_ta_addressLine1: 'ai_ta_addressLine1',
  ai_ta_addressLine2: 'ai_ta_addressLine2',
  ai_ta_city: 'ai_ta_city',
  ai_ta_country: 'ai_ta_country',
  ai_ta_county: 'ai_ta_county',
  ai_ta_countryCode: 'ai_ta_countryCode',
  pci_firstName: 'pci_firstName',
  pci_lastName: 'pci_lastName',
  pci_email: 'pci_email',
  pci_telephoneNumber: 'pci_telephoneNumber',
  pci_mobilePhoneNumber: 'pci_mobilePhoneNumber',
  pci_position: 'pci_position',
  pci_ra_eircode: 'pci_ra_eircode',
  pci_ra_addressLine1: 'pci_ra_addressLine1',
  pci_ra_addressLine2: 'pci_ra_addressLine2',
  pci_ra_city: 'pci_ra_city',
  pci_ra_country: 'pci_ra_country',
  pci_ra_county: 'pci_ra_county',
  pci_ra_countryCode: 'pci_ra_countryCode',
  usePrimaryContactInformationForBillingContact: 'usePrimaryContactInformationForBillingContact',
  usePrimaryContactInformationForServiceContact: 'usePrimaryContactInformationForServiceContact',
  bci_firstName: 'bci_firstName',
  bci_lastName: 'bci_lastName',
  bci_email: 'bci_email',
  bci_telephoneNumber: 'bci_telephoneNumber',
  bci_mobilePhoneNumber: 'bci_mobilePhoneNumber',
  bci_position: 'bci_position',
  bci_ra_eircode: 'bci_ra_eircode',
  bci_ra_addressLine1: 'bci_ra_addressLine1',
  bci_ra_addressLine2: 'bci_ra_addressLine2',
  bci_ra_city: 'bci_ra_city',
  bci_ra_country: 'bci_ra_country',
  bci_ra_countryCode: 'bci_ra_countryCode',
  sci_firstName: 'sci_firstName',
  sci_lastName: 'sci_lastName',
  sci_email: 'sci_email',
  sci_telephoneNumber: 'sci_telephoneNumber',
  sci_mobilePhoneNumber: 'sci_mobilePhoneNumber',
  sci_position: 'sci_position',
  sci_ra_eircode: 'sci_ra_eircode',
  sci_ra_addressLine1: 'sci_ra_addressLine1',
  sci_ra_addressLine2: 'sci_ra_addressLine2',
  sci_ra_city: 'sci_ra_city',
  sci_ra_country: 'sci_ra_country',
  sci_ra_countryCode: 'sci_ra_countryCode',
  bicNumber: 'bicNumber',
  ibanNumber: 'ibanNumber',
  sortCode: 'sortCode',
  accountNumber: 'accountNumber',
  commissionFrequency: 'commissionFrequency',
  partnerContractSignedAt: 'partnerContractSignedAt',
  directors: 'directors',
  userId: 'userId',
  companyIncorporationDate: 'companyIncorporationDate',
  currency: 'currency',
  country: 'country',
  contract: 'contract'
};

exports.Prisma.AccountManagerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email'
};

exports.Prisma.AddMerchantApplicationScalarFieldEnum = {
  id: 'id',
  status: 'status',
  partnerType: 'partnerType',
  partnerOfPartnerId: 'partnerOfPartnerId',
  partnerId: 'partnerId',
  serviceRequirements: 'serviceRequirements',
  merchantInformation: 'merchantInformation',
  outletInformation: 'outletInformation',
  businessInformation: 'businessInformation',
  supportingDocuments: 'supportingDocuments',
  authorId: 'authorId',
  createdAt: 'createdAt',
  merchantAccountNumber: 'merchantAccountNumber',
  dateSubmitted: 'dateSubmitted',
  firstNameOfMerchant: 'firstNameOfMerchant',
  lastNameOfMerchant: 'lastNameOfMerchant',
  worldpayPO: 'worldpayPO',
  isServiceApplication: 'isServiceApplication',
  sentToWorldpayAt: 'sentToWorldpayAt',
  cancellationDate: 'cancellationDate',
  dateOfSigning: 'dateOfSigning',
  trialPeriod: 'trialPeriod'
};

exports.Prisma.TransactionPricingOfferScalarFieldEnum = {
  id: 'id',
  offerName: 'offerName',
  revenueShare: 'revenueShare',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  status: 'status',
  idPrefix: 'idPrefix'
};

exports.Prisma.TransactionPricingCardScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  name: 'name',
  type: 'type',
  cardCategory: 'cardCategory',
  baseRate: 'baseRate',
  percentageBaseRate: 'percentageBaseRate',
  percentageLowestRate: 'percentageLowestRate',
  percentageHighestRate: 'percentageHighestRate',
  perItemBaseRate: 'perItemBaseRate',
  perItemLowestRate: 'perItemLowestRate',
  perItemHighestRate: 'perItemHighestRate',
  baseRatePercentage: 'baseRatePercentage',
  transactionPricingOfferId: 'transactionPricingOfferId'
};

exports.Prisma.AdditionalTariffChargeScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  name: 'name',
  type: 'type',
  baseRate: 'baseRate',
  lowestRate: 'lowestRate',
  highestRate: 'highestRate',
  fixedRate: 'fixedRate',
  transactionPricingOfferId: 'transactionPricingOfferId'
};

exports.Prisma.CompliancePricingChargeScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  name: 'name',
  type: 'type',
  chargeType: 'chargeType',
  baseRate: 'baseRate',
  lowestRate: 'lowestRate',
  highestRate: 'highestRate',
  fixedRate: 'fixedRate',
  transactionPricingOfferId: 'transactionPricingOfferId'
};

exports.Prisma.AdobeDocumentGenerateJobScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  assetId: 'assetId',
  documentId: 'documentId',
  sentToEmail: 'sentToEmail',
  sentToFirstName: 'sentToFirstName',
  sentToLastName: 'sentToLastName',
  documentName: 'documentName',
  documentType: 'documentType',
  jsonDataForMerge: 'jsonDataForMerge',
  jobId: 'jobId',
  downloadUrl: 'downloadUrl',
  principalSignatureIndex: 'principalSignatureIndex',
  status: 'status',
  error: 'error',
  applicationId: 'applicationId',
  merchantId: 'merchantId',
  partnerId: 'partnerId',
  notifiedAt: 'notifiedAt'
};

exports.Prisma.ServiceScalarFieldEnum = {
  id: 'id',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  merchantId: 'merchantId',
  terminalId: 'terminalId',
  applicationId: 'applicationId',
  activationDate: 'activationDate',
  contractTerm: 'contractTerm',
  cancellationDate: 'cancellationDate',
  trialEndDate: 'trialEndDate',
  trialCompletedAt: 'trialCompletedAt',
  trialCompletedById: 'trialCompletedById'
};

exports.Prisma.CommissionStatementScalarFieldEnum = {
  id: 'id',
  statementDate: 'statementDate',
  status: 'status',
  commissionStatementId: 'commissionStatementId',
  selfBillingInvoiceId: 'selfBillingInvoiceId'
};

exports.Prisma.PaymentAllocationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  salesInvoiceId: 'salesInvoiceId',
  sagePaymentId: 'sagePaymentId',
  paymentMethod: 'paymentMethod',
  status: 'status',
  unallocatedAt: 'unallocatedAt',
  allocatedAt: 'allocatedAt',
  paymentAllocatedById: 'paymentAllocatedById',
  paymentUnallocatedById: 'paymentUnallocatedById'
};

exports.Prisma.CancellationReasonScalarFieldEnum = {
  id: 'id',
  description: 'description',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  lastModifiedAt: 'lastModifiedAt',
  lastModifiedBy: 'lastModifiedBy'
};

exports.Prisma.SuspendedReasonScalarFieldEnum = {
  id: 'id',
  description: 'description',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  lastModifiedAt: 'lastModifiedAt',
  lastModifiedBy: 'lastModifiedBy'
};

exports.Prisma.OnlineCommissionStatementIdScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.TerminalCommissionStatementIdScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.TransactionCommissionStatementIdScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.SelfBillingInvoiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  partnerId: 'partnerId',
  sageInvoiceId: 'sageInvoiceId',
  sageInvoiceNumber: 'sageInvoiceNumber',
  status: 'status'
};

exports.Prisma.SelfBillingInvoiceItemScalarFieldEnum = {
  id: 'id',
  ledgerAccount: 'ledgerAccount',
  productOrService: 'productOrService',
  sageInvoiceItemId: 'sageInvoiceItemId',
  description: 'description',
  quantity: 'quantity',
  netAmount: 'netAmount',
  totalNet: 'totalNet',
  totalVat: 'totalVat',
  lineTotal: 'lineTotal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  selfBillingInvoiceId: 'selfBillingInvoiceId'
};

exports.Prisma.CreditNoteLineItemScalarFieldEnum = {
  id: 'id',
  ledgerAccount: 'ledgerAccount',
  description: 'description',
  quantity: 'quantity',
  netAmount: 'netAmount',
  totalNet: 'totalNet',
  totalVat: 'totalVat',
  lineTotal: 'lineTotal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  creditNoteId: 'creditNoteId',
  sageCreditNoteItemId: 'sageCreditNoteItemId'
};

exports.Prisma.CreditNoteScalarFieldEnum = {
  id: 'id',
  sageCreditNoteId: 'sageCreditNoteId',
  sageCreditNoteNumber: 'sageCreditNoteNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  partnerId: 'partnerId',
  merchantId: 'merchantId',
  invoiceToType: 'invoiceToType',
  salesInvoiceId: 'salesInvoiceId',
  reason: 'reason',
  totalCreditAmount: 'totalCreditAmount',
  totalCreditVatAmount: 'totalCreditVatAmount',
  totalCreditNetAmount: 'totalCreditNetAmount',
  creditNoteDate: 'creditNoteDate',
  status: 'status',
  creditAllocatedById: 'creditAllocatedById',
  creditUnallocatedById: 'creditUnallocatedById'
};

exports.Prisma.AuditLogScalarFieldEnum = {
  id: 'id',
  event: 'event',
  userId: 'userId',
  details: 'details',
  entity: 'entity',
  entityId: 'entityId',
  createdAt: 'createdAt',
  ipAddress: 'ipAddress'
};

exports.Prisma.RemoveStockReasonScalarFieldEnum = {
  id: 'id',
  description: 'description',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  lastModifiedAt: 'lastModifiedAt',
  lastModifiedBy: 'lastModifiedBy'
};

exports.Prisma.AccessTokenScalarFieldEnum = {
  id: 'id',
  accessToken: 'accessToken',
  accessTokenExpires: 'accessTokenExpires',
  refreshToken: 'refreshToken',
  refreshTokenExpires: 'refreshTokenExpires',
  scope: 'scope',
  tokenType: 'tokenType',
  createdById: 'createdById',
  createdAt: 'createdAt',
  lastModifiedById: 'lastModifiedById',
  lastModifiedAt: 'lastModifiedAt'
};

exports.Prisma.SageLedgerScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name'
};

exports.Prisma.ResourceSectionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  status: 'status',
  pinnedAt: 'pinnedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdByName: 'createdByName',
  deletedAt: 'deletedAt',
  order: 'order'
};

exports.Prisma.ResourcesScalarFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  name: 'name',
  status: 'status',
  type: 'type',
  description: 'description',
  imageUrl: 'imageUrl',
  resourceUrl: 'resourceUrl',
  createdById: 'createdById',
  lastModifiedById: 'lastModifiedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  permission: 'permission',
  deletedAt: 'deletedAt'
};

exports.Prisma.CountryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  alpha2Code: 'alpha2Code',
  capital: 'capital',
  region: 'region',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TopLevelDomainScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CallingCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TimezoneScalarFieldEnum = {
  id: 'id',
  timezone: 'timezone',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FlagScalarFieldEnum = {
  id: 'id',
  svg: 'svg',
  png: 'png',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CountryCurrencyScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  symbol: 'symbol',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReportControlScalarFieldEnum = {
  id: 'id',
  reportName: 'reportName',
  dateTimeLastRan: 'dateTimeLastRan',
  completed: 'completed',
  details: 'details'
};

exports.Prisma.IbanScalarFieldEnum = {
  id: 'id',
  country: 'country',
  code: 'code',
  length: 'length'
};

exports.Prisma.AccountStatementScalarFieldEnum = {
  id: 'id',
  accountStatementId: 'accountStatementId',
  outstandingBalance: 'outstandingBalance',
  createdAt: 'createdAt',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  statementDate: 'statementDate',
  balanceBroughtForward: 'balanceBroughtForward',
  totalInvoiceAmount: 'totalInvoiceAmount',
  totalCreditApplied: 'totalCreditApplied',
  totalPaymentsMade: 'totalPaymentsMade',
  merchantId: 'merchantId'
};

exports.Prisma.AccountStatementItemScalarFieldEnum = {
  id: 'id',
  transactionDate: 'transactionDate',
  description: 'description',
  credit: 'credit',
  debit: 'debit',
  invoiceId: 'invoiceId',
  creditNoteId: 'creditNoteId',
  paymentMethod: 'paymentMethod',
  paymentId: 'paymentId',
  merchantId: 'merchantId',
  accountStatementId: 'accountStatementId',
  itemType: 'itemType',
  rollingBalance: 'rollingBalance',
  createdAt: 'createdAt'
};

exports.Prisma.GeneratedPDFScalarFieldEnum = {
  id: 'id',
  pdfUrl: 'pdfUrl',
  status: 'status',
  templateName: 'templateName',
  createdById: 'createdById',
  accountStatementId: 'accountStatementId',
  createdAt: 'createdAt'
};

exports.Prisma.AccountingScalarFieldEnum = {
  id: 'id',
  provider: 'provider',
  providerId: 'providerId',
  displayAs: 'displayAs',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy'
};

exports.Prisma.CheckInCallScalarFieldEnum = {
  id: 'id',
  createdByID: 'createdByID',
  callName: 'callName',
  callDescription: 'callDescription',
  callType: 'callType',
  createdAt: 'createdAt',
  recurring: 'recurring',
  schedulePeriod: 'schedulePeriod',
  periodLength: 'periodLength',
  checkInTypeDays: 'checkInTypeDays',
  checkInType: 'checkInType'
};

exports.Prisma.RW_DataMigrationScalarFieldEnum = {
  version: 'version',
  name: 'name',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserStatus = exports.$Enums.UserStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  NOT_ACTIVATED: 'NOT_ACTIVATED',
  SUSPENDED: 'SUSPENDED',
  LOCKED: 'LOCKED',
  DELETED: 'DELETED'
};

exports.Hierarchy = exports.$Enums.Hierarchy = {
  NPI: 'NPI',
  PARTNER: 'PARTNER',
  PARTNER_OF_PARTNER: 'PARTNER_OF_PARTNER',
  MERCHANT: 'MERCHANT'
};

exports.BusinessStatus = exports.$Enums.BusinessStatus = {
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
  ACTIVE: 'ACTIVE'
};

exports.Currency = exports.$Enums.Currency = {
  USD: 'USD',
  EUR: 'EUR',
  JPY: 'JPY',
  GBP: 'GBP',
  AED: 'AED',
  AUD: 'AUD',
  ZAR: 'ZAR',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AWG: 'AWG',
  AZN: 'AZN'
};

exports.Language = exports.$Enums.Language = {
  ENGLISH: 'ENGLISH'
};

exports.BusinessType = exports.$Enums.BusinessType = {
  PRIVATE_LIMITED_COMPANY: 'PRIVATE_LIMITED_COMPANY',
  PUBLIC_LIMITED_COMPANY: 'PUBLIC_LIMITED_COMPANY',
  LIMITED_LIABILITY_PARTNERSHIP: 'LIMITED_LIABILITY_PARTNERSHIP',
  PARTNERSHIP: 'PARTNERSHIP',
  SOLE_TRADER: 'SOLE_TRADER',
  CHARITY_OR_NOT_FOR_PROFIT: 'CHARITY_OR_NOT_FOR_PROFIT'
};

exports.LocationType = exports.$Enums.LocationType = {
  RESIDENTIAL: 'RESIDENTIAL',
  BUSINESS: 'BUSINESS'
};

exports.StatementFrequency = exports.$Enums.StatementFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY'
};

exports.RISK = exports.$Enums.RISK = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  PROHIBITED: 'PROHIBITED',
  RESTRICTED: 'RESTRICTED'
};

exports.MerchantStatus = exports.$Enums.MerchantStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED'
};

exports.BankAccountType = exports.$Enums.BankAccountType = {
  SETTLEMET_ACCOUNT: 'SETTLEMET_ACCOUNT',
  CHARGEABLE_ACCOUNT: 'CHARGEABLE_ACCOUNT',
  SETTLEMENT_ACCOUNT: 'SETTLEMENT_ACCOUNT'
};

exports.ServiceCharges = exports.$Enums.ServiceCharges = {
  FLAT_RATE: 'FLAT_RATE'
};

exports.FileType = exports.$Enums.FileType = {
  ID: 'ID',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  APPLICATION_DOC: 'APPLICATION_DOC',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  TRANSACTION_DOC: 'TRANSACTION_DOC',
  B1_FORM: 'B1_FORM'
};

exports.CommissionType = exports.$Enums.CommissionType = {
  ONLINE: 'ONLINE',
  TERMINAL: 'TERMINAL',
  TRANSACTIONAL: 'TRANSACTIONAL'
};

exports.PricingTerm = exports.$Enums.PricingTerm = {
  O12_MONTHS: 'O12_MONTHS',
  O18_MONTHS: 'O18_MONTHS',
  O24_MONTHS: 'O24_MONTHS',
  O36_MONTHS: 'O36_MONTHS',
  O48_MONTHS: 'O48_MONTHS',
  CUSTOM: 'CUSTOM'
};

exports.PricingType = exports.$Enums.PricingType = {
  TERMINAL: 'TERMINAL',
  ONLINE: 'ONLINE',
  TRANSACTIONAL: 'TRANSACTIONAL'
};

exports.OfferStatus = exports.$Enums.OfferStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  DELETED: 'DELETED'
};

exports.SalesConditions = exports.$Enums.SalesConditions = {
  NO: 'NO',
  YES: 'YES'
};

exports.ProductCatalogue = exports.$Enums.ProductCatalogue = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};

exports.ProductType = exports.$Enums.ProductType = {
  ONLINE: 'ONLINE',
  TERMINAL: 'TERMINAL'
};

exports.ProductStatus = exports.$Enums.ProductStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  DELETED: 'DELETED'
};

exports.ServiceType = exports.$Enums.ServiceType = {
  ONLINE: 'ONLINE',
  TERMINAL: 'TERMINAL',
  ACQUIRING_ONLY: 'ACQUIRING_ONLY'
};

exports.PricingStatus = exports.$Enums.PricingStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  DELETED: 'DELETED',
  LEGACY: 'LEGACY'
};

exports.FeeProgramme = exports.$Enums.FeeProgramme = {
  PER_ITEM: 'PER_ITEM',
  FIXED: 'FIXED'
};

exports.InvoiceTo = exports.$Enums.InvoiceTo = {
  PARTNER: 'PARTNER',
  MERCHANT: 'MERCHANT'
};

exports.BillingCycle = exports.$Enums.BillingCycle = {
  RECURRING: 'RECURRING',
  ONE_OFF: 'ONE_OFF'
};

exports.InvoiceOccurrence = exports.$Enums.InvoiceOccurrence = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

exports.OccurrenceType = exports.$Enums.OccurrenceType = {
  FIXED_OCCURRENCE: 'FIXED_OCCURRENCE',
  CREATE_UNTIL_CANCEL: 'CREATE_UNTIL_CANCEL'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  VOID: 'VOID',
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  PARTIALLY_FAILED: 'PARTIALLY_FAILED',
  FAILED: 'FAILED'
};

exports.SageInvoiceStatus = exports.$Enums.SageInvoiceStatus = {
  UNPAID: 'UNPAID',
  PART_PAID: 'PART_PAID',
  PAID: 'PAID',
  VOID: 'VOID',
  DRAFT: 'DRAFT',
  DISPUTED: 'DISPUTED',
  DECLINED: 'DECLINED',
  PRO_FORMA: 'PRO_FORMA'
};

exports.PartnerType = exports.$Enums.PartnerType = {
  NPI: 'NPI',
  PARTNER: 'PARTNER',
  PARTNER_OF_PARTNER: 'PARTNER_OF_PARTNER',
  MERCHANT: 'MERCHANT'
};

exports.CommissionFrequency = exports.$Enums.CommissionFrequency = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

exports.ApplicationStatus = exports.$Enums.ApplicationStatus = {
  DRAFT: 'DRAFT',
  AWAITING_SIGNATURE: 'AWAITING_SIGNATURE',
  ERROR_IDENTIFIED: 'ERROR_IDENTIFIED',
  NPI_INTERNAL_CS_REVIEW: 'NPI_INTERNAL_CS_REVIEW',
  AWAITING_HARDWARE_DISPATCH: 'AWAITING_HARDWARE_DISPATCH',
  SENT_TO_WORLDPAY_AWAITING_MID: 'SENT_TO_WORLDPAY_AWAITING_MID',
  APPLICATION_ACCEPTED: 'APPLICATION_ACCEPTED',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  AWAITING_SUPPORTING_DOCUMENTS: 'AWAITING_SUPPORTING_DOCUMENTS'
};

exports.TransactionPricingCardType = exports.$Enums.TransactionPricingCardType = {
  PERCENTAGE: 'PERCENTAGE',
  PER_ITEM: 'PER_ITEM',
  BOTH: 'BOTH'
};

exports.TransactionPricingType = exports.$Enums.TransactionPricingType = {
  PERSONAL_CARDS: 'PERSONAL_CARDS',
  COMMERCIAL_CARDS: 'COMMERCIAL_CARDS',
  OTHER: 'OTHER'
};

exports.AdditionalTariffChargeType = exports.$Enums.AdditionalTariffChargeType = {
  PER_ITEM: 'PER_ITEM',
  FIXED: 'FIXED'
};

exports.CompliancePricingChargeType = exports.$Enums.CompliancePricingChargeType = {
  WORLDPAY_PROGRAMME: 'WORLDPAY_PROGRAMME',
  SAFE_PAYMENTS: 'SAFE_PAYMENTS'
};

exports.DocumentType = exports.$Enums.DocumentType = {
  MERCHANT_APPLICATION: 'MERCHANT_APPLICATION',
  PARTNER_SEPA_DD: 'PARTNER_SEPA_DD',
  MERCHANT_SEPA_DD: 'MERCHANT_SEPA_DD'
};

exports.AdobeJobStatus = exports.$Enums.AdobeJobStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  FAILED: 'FAILED',
  SIGNED: 'SIGNED',
  CANCELLED: 'CANCELLED',
  OUT_FOR_SIGNATURE: 'OUT_FOR_SIGNATURE',
  EXPIRED: 'EXPIRED'
};

exports.ServiceStatus = exports.$Enums.ServiceStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  NPI_INTERNAL_CS_REVIEW: 'NPI_INTERNAL_CS_REVIEW',
  CANCELLED: 'CANCELLED'
};

exports.CommissionStatementStatus = exports.$Enums.CommissionStatementStatus = {
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID'
};

exports.PaymentAllocationStatus = exports.$Enums.PaymentAllocationStatus = {
  ALLOCATED: 'ALLOCATED',
  UNALLOCATED: 'UNALLOCATED'
};

exports.ConfigurationStatus = exports.$Enums.ConfigurationStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED'
};

exports.ProductOrService = exports.$Enums.ProductOrService = {
  ONLINE: 'ONLINE',
  TERMINAL: 'TERMINAL',
  TRANSACTION: 'TRANSACTION'
};

exports.CreditNoteInvoiceTo = exports.$Enums.CreditNoteInvoiceTo = {
  MERCHANT: 'MERCHANT',
  PARTNER: 'PARTNER'
};

exports.CreditNoteStatus = exports.$Enums.CreditNoteStatus = {
  CREDITED: 'CREDITED',
  PARTIALLY_CREDITED: 'PARTIALLY_CREDITED',
  OPEN: 'OPEN'
};

exports.EventType = exports.$Enums.EventType = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT'
};

exports.AuditLogEntity = exports.$Enums.AuditLogEntity = {
  USER: 'USER',
  MERCHANT: 'MERCHANT',
  PARTNER: 'PARTNER',
  PARTNER_OF_PARTNER: 'PARTNER_OF_PARTNER',
  ADD_MERCHANT_APPLICATION: 'ADD_MERCHANT_APPLICATION',
  PARTNER_APPLICATION: 'PARTNER_APPLICATION',
  SERVICE: 'SERVICE',
  INVOICE: 'INVOICE',
  CREDIT_NOTE: 'CREDIT_NOTE',
  PRICING: 'PRICING',
  OFFER: 'OFFER',
  RESOURCE_SECTION: 'RESOURCE_SECTION',
  RESOURCE: 'RESOURCE',
  PRODUCT: 'PRODUCT',
  CONTRACT: 'CONTRACT',
  DOCUMENT: 'DOCUMENT',
  GENERATE_PDF: 'GENERATE_PDF',
  ADD_CHECK_IN_CALL: 'ADD_CHECK_IN_CALL'
};

exports.TokenType = exports.$Enums.TokenType = {
  SAGE: 'SAGE'
};

exports.ResourceType = exports.$Enums.ResourceType = {
  Document: 'Document',
  Link: 'Link',
  Video: 'Video'
};

exports.AddResourcePermissionType = exports.$Enums.AddResourcePermissionType = {
  ALL_PARTNERS: 'ALL_PARTNERS',
  PARTNERS: 'PARTNERS',
  PARTNER_OF_PARTNERS: 'PARTNER_OF_PARTNERS'
};

exports.AccountStatementItemType = exports.$Enums.AccountStatementItemType = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  INVOICE: 'INVOICE',
  PAYMENT: 'PAYMENT',
  BALANCE: 'BALANCE'
};

exports.PDFStatus = exports.$Enums.PDFStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.AccountingProviderType = exports.$Enums.AccountingProviderType = {
  SAGE: 'SAGE',
  XERO: 'XERO',
  QUICKBOOKS: 'QUICKBOOKS',
  OTHER: 'OTHER'
};

exports.CheckInCallType = exports.$Enums.CheckInCallType = {
  SCHEDULED_CALL: 'SCHEDULED_CALL',
  AFTER_EVENT: 'AFTER_EVENT'
};

exports.SchedulePeriod = exports.$Enums.SchedulePeriod = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY'
};

exports.CheckInType = exports.$Enums.CheckInType = {
  CANCELLATION: 'CANCELLATION',
  NEARING_EXPIRY: 'NEARING_EXPIRY',
  TRIAL_PERIOD: 'TRIAL_PERIOD'
};

exports.Prisma.ModelName = {
  User: 'User',
  Business: 'Business',
  Role: 'Role',
  RolePermissions: 'RolePermissions',
  Password: 'Password',
  Address: 'Address',
  Location: 'Location',
  Partner: 'Partner',
  PartnerOfPartner: 'PartnerOfPartner',
  Merchant: 'Merchant',
  MCC: 'MCC',
  Bank: 'Bank',
  Outlet: 'Outlet',
  Note: 'Note',
  Document: 'Document',
  Commission: 'Commission',
  Offer: 'Offer',
  Product: 'Product',
  TerminalProductId: 'TerminalProductId',
  OnlineProductId: 'OnlineProductId',
  File: 'File',
  Pricing: 'Pricing',
  Promo: 'Promo',
  Invoice: 'Invoice',
  InvoiceItem: 'InvoiceItem',
  AddPartnerApplication: 'AddPartnerApplication',
  AccountManager: 'AccountManager',
  AddMerchantApplication: 'AddMerchantApplication',
  TransactionPricingOffer: 'TransactionPricingOffer',
  TransactionPricingCard: 'TransactionPricingCard',
  AdditionalTariffCharge: 'AdditionalTariffCharge',
  CompliancePricingCharge: 'CompliancePricingCharge',
  AdobeDocumentGenerateJob: 'AdobeDocumentGenerateJob',
  Service: 'Service',
  CommissionStatement: 'CommissionStatement',
  PaymentAllocation: 'PaymentAllocation',
  CancellationReason: 'CancellationReason',
  SuspendedReason: 'SuspendedReason',
  OnlineCommissionStatementId: 'OnlineCommissionStatementId',
  TerminalCommissionStatementId: 'TerminalCommissionStatementId',
  TransactionCommissionStatementId: 'TransactionCommissionStatementId',
  SelfBillingInvoice: 'SelfBillingInvoice',
  SelfBillingInvoiceItem: 'SelfBillingInvoiceItem',
  CreditNoteLineItem: 'CreditNoteLineItem',
  CreditNote: 'CreditNote',
  AuditLog: 'AuditLog',
  RemoveStockReason: 'RemoveStockReason',
  AccessToken: 'AccessToken',
  SageLedger: 'SageLedger',
  ResourceSection: 'ResourceSection',
  Resources: 'Resources',
  Country: 'Country',
  TopLevelDomain: 'TopLevelDomain',
  CallingCode: 'CallingCode',
  Timezone: 'Timezone',
  Flag: 'Flag',
  CountryCurrency: 'CountryCurrency',
  ReportControl: 'ReportControl',
  Iban: 'Iban',
  AccountStatement: 'AccountStatement',
  AccountStatementItem: 'AccountStatementItem',
  GeneratedPDF: 'GeneratedPDF',
  Accounting: 'Accounting',
  CheckInCall: 'CheckInCall',
  RW_DataMigration: 'RW_DataMigration'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
